export const QUERY__CATEGORIES = 'categories';
export const QUERY__SUB_CATEGORIES = 'sub-categories-of-category';
export const QUERY__CATEGORY = 'category';
export const QUERY__UNMAPPED_EXTERNAL_SUB_CATEGORIES =
  'unmapped-external-sub-categories';
export const QUERY__BOUND_EXTERNAL_SUB_CATEGORIES =
  'bound-external-sub-categories';
